<div class="color-container">
    @if (value === "") {
        <cerrix-icon
            class="add-color"
            icon="add-new"
            [attr.data-uiid]="dataUiid + '-add-color'"
            [size]="16"
            color="#5997FF"
        ></cerrix-icon>
    }
    @if (ngControl?.control) {
        <input
            class="color-input"
            [class.empty]="value === ''"
            type="color"
            [attr.data-uiid]="dataUiid + '-color-input'"
            [title]="value === '' ? 'Choose a color' : value"
            [formControl]="$any(ngControl!.control)"
            (input)="onChange($event)"
        />
    } @else {
        <input
            class="color-input"
            [class.empty]="value === ''"
            type="color"
            [attr.data-uiid]="dataUiid + '-color-input'"
            [title]="value === '' ? 'Choose a color' : value"
            [disabled]="disabled"
            [ngModel]="value"
            (input)="onChange($event)"
        />
    }
    @if (allowEmpty && value !== "") {
        <cerrix-icon
            class="clear-color"
            icon="close-small"
            [size]="10"
            [attr.data-uiid]="dataUiid + '-clear-color'"
            color="#fff"
            (click)="clearColor()"
        ></cerrix-icon>
    }
</div>

@if (ngControl?.control?.errors) {
    <div class="cerrix-form-field-error-wrapper">
        @for (error of ngControl!.control!.errors | errorMessages; track error) {
            <div class="form-field-error">
                {{ error }}
            </div>
        }
    </div>
}
